// extracted by mini-css-extract-plugin
export default {"filter":"category_filter_filter__CRzrp","Mui-focused":"category_filter_Mui-focused__zKoXh","label":"category_filter_label__5Rmii"};